import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { ACTIONS_TYPE, PRIVATE_ROUTE } from 'utils/constants';
import ability from 'utils/ability/ability';
import { FeatureActivation } from 'features/components/FeatureActivation';
import { AppContext } from 'AppContext';
import InfoIcon from 'atoms/InfoIcon';
import { FormattedMessage } from 'react-intl';
import { FeatureDeactivation } from 'features/components/FeatureDeactivation';
import DailyGoalSettings from './DailyGoalSettings';

const DailyGoalsSettings = () => {
  const [activated, setActivated] = useState(
    ability.can('use', 'daily_goals_feature')
  );
  const { dispatch } = useContext(AppContext);
  const Title = () => (
    <InfoIcon title={<FormattedMessage id="dailyGoals.text" />} />
  );

  useEffect(() => {
    dispatch({ type: ACTIONS_TYPE.SETTING_TITLE, data: <Title /> });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  if (!activated) {
    return (
      <FeatureActivation
        featureKey="daily_goals_feature"
        setActivated={setActivated}
      />
    );
  }

  return (
    <div>
      {/* <DailyGoalSettings /> //todo: add settings for Daily Goals */}
      <FeatureDeactivation
        featureKey="daily_goals_feature"
        setActivated={setActivated}
      />
    </div>
  );
};

export default {
  component: withRouter(DailyGoalsSettings),
  path: PRIVATE_ROUTE.SETTINGS.SUB_ROUTE.DAILY_GOAL_SETTINGS,
  key: 'daily-goals-settings',
  abilityAction: 'manage',
  abilitySubject: 'daily goals settings',
  icon: (
    <i
      data-eva="checkmark-circle-outline"
      data-eva-height="20"
      data-eva-width="20"
    >
    </i>
  ),
  text: <FormattedMessage id="dailyGoalsSettings.text" />,
};
